import { queryOptions } from '@tanstack/react-query'
import { axios } from '../../common'
import {
  RoleSearchParams,
  RoleSearchResult,
  RoleSearchResultSchema,
} from './list.schema'

export async function fetchRoles(
  opts: RoleSearchParams
): Promise<RoleSearchResult> {
  const response = await axios.get('/api/masterdata/roles', {
    params: opts,
  })
  return RoleSearchResultSchema.parse(response.data)
}

export const fetchRolesQueryOptions = (opts: RoleSearchParams) =>
  queryOptions({
    queryKey: ['roles', opts],
    queryFn: () => fetchRoles(opts),
  })
